export default __webpack_public_path__ + "static/media/instituto-barueri.82198a80.svg";